/**
 * Action for Fetch Source Registry List
 */
export enum fetchSourceRegistryList {
  FETCH_SOURCE_REGISTRY_LIST_REQUEST = 'FFETCH_SOURCE_REGISTRY_LIST_REQUEST'
}
